export default __webpack_public_path__ + "static/studio-slider-23-9cde1b102e0e72dd0e2b1c3d72f3cdb5.png";